<template>
  <div
    class="page safe-distance-top"
    :style="{
      backgroundColor:
        signInfo.fgDis === 0 && signInfo.fgDel === 0 && !isSign
          ? '#f5f5f5'
          : '#fff',
    }"
  >
    <div class="loading-box" v-if="pageLoading">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
    <div v-else>
      <!-- <Header pageTitle="会议签到" /> -->
      <template v-if="signInfo.fgDis === 0 && signInfo.fgDel === 0">
        <template v-if="isSign">
          <div>
            <div class="success-box-top">
              <img src="@/assets/img/mobile-img/success-icon.png" alt="" />
              <p>签到成功</p>
            </div>
            <div v-if="attendPrompt">
              <div class="divider"></div>
              <div style="padding: 15px" v-html="attendPrompt"></div>
            </div>
            <div class="divider"></div>
            <div class="success-box-bottom">
              <div class="success-box-item">
                <span class="item-label">参会人</span>
                <span class="item-content">{{ signUserInfo.name }}</span>
              </div>
              <div class="success-box-item">
                <span class="item-label">签到时间</span>
                <span class="item-content">{{
                  signUserInfo.attendSignTime
                }}</span>
              </div>
              <div class="success-box-item">
                <span class="item-label">票种信息</span>
                <span class="item-content">{{ signUserInfo.skuName }}</span>
              </div>
              <!-- <div class="success-box-item">
                <span class="item-label">票种价格</span>
                <span class="item-content">{{ signUserInfo.skuPrice }}</span>
              </div> -->
            </div>
          </div>
        </template>
        <template v-else>
          <div style="padding: 12px">
            <div class="box box-top">
              <h1 class="sign-title">{{ signInfo.attendTaskNm }}</h1>
              <p class="sign-info">签到时间：</p>
              <p class="sign-info">
                <span>{{ signInfo.dtmStart.slice(0, 16) }}</span>
                <span style="margin: 0 5px">至</span>
                <span>{{ signInfo.dtmEnd.slice(0, 16) }}</span>
              </p>
            </div>
            <div class="box" v-if="signInfo.attendDetail">
              <h1 class="sign-title">签到详情</h1>
              <div class="sign-content" v-html="signInfo.attendDetail"></div>
            </div>
            <div class="sign-bottom">
              <van-button round type="info" @click="toSign">签到</van-button>
            </div>
            <van-popup
              v-model="signPopupShow"
              round
              :close-on-click-overlay="false"
            >
              <div class="signPopup-box">
                <h4>签到</h4>
                <p class="title-tip">
                  <span style="color: red">*</span>
                  <span>{{
                    `输入报名时填写的参会人${
                      signInfo.verifyType === 1 ? "姓名+" : ""
                    }手机号进行签到`
                  }}</span>
                </p>
                <van-form ref="signFormRef" @submit="onSubmit">
                  <van-field v-show="false" v-model="signForm.id" name="id" />
                  <van-field
                    v-if="signInfo.verifyType === 1"
                    class="form-item"
                    v-model.trim="signForm.name"
                    name="name"
                    placeholder="请输入姓名"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                  />
                  <van-field
                    class="form-item"
                    v-model.trim="signForm.phone"
                    name="phone"
                    placeholder="请输入手机号"
                    @input="resultStatus = false"
                    :rules="[
                      { required: true, message: '请输入手机号' },
                      {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '请输入正确格式的手机号码',
                        trigger: 'onBlur',
                      },
                    ]"
                  />
                  <p v-if="resultStatus" class="error-tip">
                    未找到“{{
                      signForm.name || signForm.phone
                    }}”的参会信息，请确认内容是否有误
                  </p>
                  <van-button
                    type="default"
                    plain
                    :round="true"
                    native-type="reset"
                    @click="cancelSign"
                  >
                    取消
                  </van-button>
                  <van-button type="info" :round="true" native-type="submit">
                    确认签到
                  </van-button>
                </van-form>
              </div>
            </van-popup>
            <van-popup
              v-model="noInfoPopupShow"
              round
              :close-on-click-overlay="false"
            >
              <div class="signPopup-box">
                <img
                  class="signPopup-icon"
                  src="@/assets/mylogin/gantanhao-2.png"
                  alt=""
                />
                <p class="title-tip">
                  未查询到您的参会信息，请确认您已报名本会议
                </p>
                <van-button
                  type="default"
                  plain
                  :round="true"
                  @click="noInfoPopupShow = false"
                >
                  取消
                </van-button>
                <van-button
                  type="info"
                  :round="true"
                  @click="$router.push('/logins')"
                  >重新登录</van-button
                >
              </div>
            </van-popup>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="error-box">
          <img
            class="error-icon"
            src="@/assets/mylogin/gantanhao-2.png"
            alt=""
          />
          <p v-if="signInfo.fgDis === 1" class="error-title">
            二维码已失效，请联系会议方
          </p>
          <p v-if="signInfo.fgDel === 1" class="error-title">此签到已删除</p>
          <div v-if="signInfo.fgDel === 1">
            <van-button type="info" plain :round="true" @click="toMeeting">
              返回会议
            </van-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import Header from "@/views/mobileView/components/header";
export default {
  // components: {
  //   Header,
  // },
  data() {
    return {
      isSign: false,
      signInfo: {},
      signPopupShow: false,
      signForm: {
        id: "",
        name: "",
        phone: "",
      },
      resultStatus: false,
      noInfoPopupShow: false,
      signUserInfo: {},
      attendPrompt: "",
      pageLoading: false,
    };
  },
  created() {
    document.title = "会议签到";
    this.getSignInfo(this.$route.query.id, this.$route.query.check);
  },
  methods: {
    async getSignInfo(id, check) {
      this.pageLoading = true;
      const res = await this.$apis.signServe.signDetail({ id, check });
      console.log(res, "res");
      if (res.resultCode === "200") {
        this.signInfo = res.data;
        this.signForm.id = res.data.id;
        if (res.data.attendFlag) {
          this.isSign = true;
          this.signUserInfo = res.data.meetingMemberAttendDTO;
          this.attendPrompt = res.data.attendPrompt;
        }
      } else {
        this.$set(this.signInfo, "fgDis", 1);
      }
      this.pageLoading = false;
    },
    async toSign() {
      if (this.signInfo.attendType === 0) {
        this.tokens = sessionStorage.getItem("token");
        if (this.tokens) {
          console.log("登录");
          let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          let obj = {
            id: this.signForm.id,
            phone: userInfo.account,
          };
          if (this.signInfo.verifyType === 1) obj.name = userInfo.name;
          this.onSubmit(obj, true);
        } else {
          // 如果未登录，跳转登录页
          console.log("未登录");
          this.$router.push("/logins");
        }
      } else {
        this.signPopupShow = true;
      }
    },
    async onSubmit(values, isLogin = false) {
      console.log(values, "valuse");
      const res = await this.$apis.signServe.signSubmit(values);
      console.log(res, "res");
      if (res.resultCode === "200") {
        let { code } = res.content;
        console.log(code, "code");
        if (isLogin) {
          // 有code 代表签到不成功
          if (code !== undefined) {
            if (code === 2) {
              this.noInfoPopupShow = true;
            } else {
              this.$toast(res.resultDesc);
            }
          } else {
            this.getSignInfo(this.$route.query.id, this.$route.query.check);
          }
        } else {
          // 有code 代表签到不成功
          if (code !== undefined) {
            if (code === 2) {
              this.resultStatus = true;
            } else {
              this.$toast(res.resultDesc);
            }
          } else {
            this.isSign = true;
            this.signUserInfo = res.data;
            this.attendPrompt = res.data.attendPrompt;
          }
        }
      } else {
        this.$toast(res.resultDesc);
      }
    },
    cancelSign() {
      this.signPopupShow = false;
      this.resultStatus = false;
      this.signForm.name = "";
      this.signForm.phone = "";
      this.$refs.signFormRef.resetValidation();
    },
    toMeeting() {
      if (this.signInfo.meetingId) {
        window.open(
          this.$global.meetingH5Url +
            `pagesModule/meetingDetails/index?type=8&id=${
              this.signInfo.bId || this.signInfo.meetingId
            }&open=1`,
          "_self"
        );
      } else {
        this.$toast("没有查到相关会议");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  padding-bottom: 60px;
  min-height: 100vh;
  overflow: hidden;
  .box {
    margin-bottom: 12px;
    padding: 15px;
    border-radius: 8px;
    background-color: #fff;
    .sign-title {
      margin-bottom: 15px;
      font-size: 17px;
      color: #333333;
      line-height: 24px;
    }
    .sign-content {
      font-size: 14px;
      color: #333333;
      line-height: 21px;
    }
  }
  .box-top {
    background: linear-gradient(180deg, #e8eeff 0%, #ffffff 100%);
    .sign-info {
      margin-top: 9px;
      font-size: 13px;
      color: #666666;
      line-height: 19px;
    }
  }
  .success-box-top {
    padding: 30px 0;
    text-align: center;
    img {
      width: 83px;
      height: 83px;
    }
    p {
      font-size: 16px;
      color: #333333;
      line-height: 23px;
    }
  }
  .divider {
    height: 10px;
    background-color: #f5f5f5;
  }
  .success-box-bottom {
    height: 100%;
    .success-box-item {
      padding: 15px;
      border-bottom: 1px solid #eee;
      .item-label {
        display: inline-block;
        width: 65px;
        font-size: 15px;
        color: #999999;
        line-height: 21px;
      }
      .item-content {
        margin-left: 25px;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
      }
    }
  }
  .error-box {
    position: absolute;
    top: 50vh;
    left: 0;
    margin-top: -40%;
    width: 100vw;
    text-align: center;
    .error-icon {
      margin-bottom: 12px;
      width: 65px;
      height: 65px;
    }
    .error-title {
      font-size: 16px;
      color: #333333;
      line-height: 23px;
    }
    button {
      margin-top: 33px;
      width: 130px;
    }
  }
  .sign-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 6px 15px;
    width: 100vw;
    text-align: center;
    background-color: #fff;
    button {
      width: 100%;
    }
  }
  .loading-box {
    padding-top: 50%;
  }
}
.signPopup-box {
  padding: 20px;
  width: 315px;
  h4 {
    margin-bottom: 20px;
    text-align: center;
    font-size: 16px;
    color: #333333;
    line-height: 23px;
  }
  .title-tip {
    margin-bottom: 20px;
    font-size: 14px;
    color: #333;
  }
  .form-item {
    margin-bottom: 12px;
    background-color: #f5f5f5;
    border-radius: 6px;
  }
  .error-tip {
    margin-bottom: 18px;
    font-size: 13px;
    color: #ff0000;
    line-height: 21px;
  }
  .signPopup-icon {
    display: block;
    margin: 0 auto 23px;
    width: 35px;
    height: 35px;
  }
  &::v-deep .van-button {
    width: 130px;
    height: 40px;
    &:last-child {
      margin-left: 15px;
    }
  }
}
</style>
